import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Styles/Festivals.css";

function Festivals() {

  const [festivals, setFestivals] = useState([]);
  const [selectedFestival, setSelectedFestival] = useState(null);

  // ==========================================
  // FETCH FESTIVALS FROM DATABASE
  // ==========================================

  useEffect(() => {

    axios
      .get("http://localhost:8080/api/festivals")
      .then((response) => {

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const upcoming = response.data
          .filter((festival) => {

            if (!festival.active || !festival.date) {
              return false;
            }

            const festivalDate = new Date(festival.date);
            festivalDate.setHours(0, 0, 0, 0);

            return festivalDate >= today;
          })
          .sort(
            (a, b) =>
              new Date(a.date) - new Date(b.date)
          );

        setFestivals(upcoming);

      })
      .catch((error) => {
        console.error(
          "Error fetching festivals:",
          error
        );
      });

  }, []);


  // ==========================================
  // FORMAT DATE
  // ==========================================

  const formatDate = (date) => {

    return new Date(date).toLocaleDateString(
      "en-IN",
      {
        day: "numeric",
        month: "long",
        year: "numeric"
      }
    );

  };


  // ==========================================
  // VIEW DETAILS
  // ==========================================

  const handleViewDetails = (festival) => {

    setSelectedFestival(festival);

  };


  return (

    <div className="festival-page">


      {/* =====================================
          UPCOMING FESTIVALS
          ===================================== */}

      <div className="container py-5">

        <h2 className="festival-title">
          Upcoming Festivals
        </h2>


        <div className="row">

          {festivals.length === 0 ? (

            <div className="col-12 text-center">

              <p>
                No upcoming festivals available.
              </p>

            </div>

          ) : (

            festivals.map((festival) => (

              <div
                className="col-lg-4 col-md-6 mb-4"
                key={festival.id}
              >

                <div className="card festival-card h-100">


                  {/* Festival Image */}

                  {festival.imageName && (

                    <img
                      src={`http://localhost:8080/uploads/festivals/${festival.imageName}`}
                      alt={festival.name}
                      className="festival-image"
                    />

                  )}


                  <div className="card-body">

                    <h3>
                      {festival.name}
                    </h3>


                    <h6 className="festival-date">

                      {formatDate(festival.date)}

                    </h6>


                    <p>
                    
                    </p>

                  </div>


                  <div className="card-footer bg-white border-0 text-center ">

                    <button 
                      className="btn btn-warning "
                      onClick={() =>
                        handleViewDetails(festival)
                      }
                    >
                      View Details
                    </button>

                  </div>

                </div>

              </div>

            ))

          )}

        </div>


        {/* =====================================
            SELECTED FESTIVAL DETAILS
            ===================================== */}

        {selectedFestival && (

          <div className="festival-details">

            <h2>
              {selectedFestival.name}
            </h2>


            <h5 className="text-center festival-date">

              {formatDate(
                selectedFestival.date
              )}

            </h5>


            <p>
              {selectedFestival.description}
            </p>


            <div className="text-center mt-4">

              <button
                className="btn btn-secondary"
                onClick={() =>
                  setSelectedFestival(null)
                }
              >
                Close
              </button>

            </div>

          </div>

        )}

      </div>


      {/* =====================================
          FESTIVAL HIGHLIGHTS
          ===================================== */}

      <section className="festival-schedule">

        <div className="container">

          <h2>
            Festival Highlights
          </h2>


          <div className="row text-center mt-4">

            <div className="col-md-3">

              <h4>🎶</h4>

              <p>
                Traditional Melam
              </p>

            </div>


            <div className="col-md-3">

              <h4>🪔</h4>

              <p>
                Special Poojas
              </p>

            </div>


            <div className="col-md-3">

              <h4>🍚</h4>

              <p>
                Annadanam
              </p>

            </div>


            <div className="col-md-3">

              <h4>🐘</h4>

              <p>
                Temple Procession
              </p>

            </div>

          </div>

        </div>

      </section>

    </div>

  );

}

export default Festivals;
